import { ChevronRightIcon } from 'lucide-react'
import { Link } from 'react-router-dom'
import { contentTypeLabels, TopicLandingContentType } from '../utils/guide.utils'

type TopicLandingCardProps = {
  title: string
  href: string
  subTabTitle?: string | null
  contentType: TopicLandingContentType
}

export const TopicLandingCard = ({
  title,
  href,
  subTabTitle,
  contentType,
}: TopicLandingCardProps) => {
  return (
    <li className="relative flex justify-between gap-x-6 px-6 py-4 transition-colors hover:bg-accent/50">
      <div className="min-w-0 flex-1">
        <p className="text-xs text-foreground">{subTabTitle}</p>
        <p className="mt-1 text-sm font-semibold text-foreground">
          <Link to={href}>
            <span className="absolute inset-0" />
            {title}
          </Link>
        </p>
      </div>

      <div className="ml-4 flex shrink-0 items-center gap-1">
        <span className="hidden text-xs text-muted-foreground sm:inline">
          {contentTypeLabels[contentType]}
        </span>
        <ChevronRightIcon aria-hidden="true" className="size-4 text-rexBlue" />
      </div>
    </li>
  )
}
